export abstract class Model {
  /**
   * This method takes a plain object in input and returns a model instance
   * @param input a plain object representing the model
   */
  public static deserialize(input: any) {
    const obj = Object.create(this.prototype);
    Object.assign(obj, input);
    obj.afterDeserialize(input);
    return obj;
  }

  /**
   * afterDeserialize method is called automatically on the deserialized object
   */
  protected afterDeserialize(input: any): void {}
}
